import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion'
import { FiArrowRight } from 'react-icons/fi'

import Sectionbureau from '../../components/Sectionbureau/Sectionbureau';
import './SectionTable.css'

const SectionTable = () => {

  const [infob, setInfob] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/table/lister6`)
      .then(res => {
        setInfob(res.data)
        setIsLoading(false)
      })
      .catch(err => {
        console.error("Erreur lors du chargement des données:", err)
        setIsLoading(false)
      })
  }, [])

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  }

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.5, ease: "easeOut" }
    }
  }

  const cards = infob.map((card) => (
    <motion.div
      key={card._id}
      className='col-lg-3 col-md-4 col-6 mb-4'
      variants={itemVariants}
    >
      <Sectionbureau
        nom={card.nom}
        titre={card.titre}
        prix={card.prix1}
        image={card.image}
        id={card._id}
      />
    </motion.div>
  ))

  return (
    <div className='container hd-seltable py-5'>
      <motion.div
        className="hd-seltable-header"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <span className="hd-seltable-eyebrow">Notre sélection</span>
        <h2 className="hd-seltable-title">
          Collection <em>Table</em>
          <motion.span
            className="hd-seltable-underline"
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 0.8, delay: 0.3, ease: [0.16, 1, 0.3, 1] }}
          />
        </h2>
        <p className="hd-seltable-subtitle">
          Découvrez notre sélection exclusive de tables design et fonctionnelles
        </p>
      </motion.div>

      {isLoading ? (
        <div className="d-flex justify-content-center py-5">
          <div className="spinner-grow hd-seltable-spinner" role="status">
            <span className="visually-hidden">Chargement...</span>
          </div>
        </div>
      ) : (
        <motion.div
          className='row'
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          {cards}
        </motion.div>
      )}

      <motion.div
        className="hd-seltable-more"
        initial={{ opacity: 0, y: 10 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        <Link to="/table" className="hd-seltable-btn">
          <span>Voir toute la collection</span>
          <FiArrowRight />
        </Link>
      </motion.div>

      <motion.div
        className="hd-seltable-divider"
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
      />
    </div>
  )
}

export default SectionTable
